import { useState, useCallback, useMemo } from "react"
import PropTypes from "prop-types"
import classNames from "classnames"
import { isEmpty, map } from "lodash"
import { connect } from "react-redux"
import { Link, useNavigate } from "react-router-dom"
import { IconButton, Menu, MenuItem } from "@mui/material"
import { MoreVert } from "@mui/icons-material"

import "./styles.scss"

function ContextualMenu({ items, dispatch, disabled = false, className = "" }) {
  const [anchorEl, setAnchorEl] = useState(null)
  const navigate = useNavigate()

  const makeOnClick = useCallback((action) => () => {
    setAnchorEl(null)
    if (!action) { return }
    action(dispatch, navigate)
  }, [dispatch, navigate])

  const menuItems = useMemo(() => map(items, ({ id, label, action, to, className }) => {
    if (to) {
      return <MenuItem key={id} className={classNames(className)} component={Link} to={to}>{label}</MenuItem>
    }
    return <MenuItem key={id} className={classNames(className)} onClick={makeOnClick(action)}>{label}</MenuItem>
  }), [items, makeOnClick])

  if (isEmpty(items)) { return null }
  return <span className={classNames("component_contextual-resource-menu", className)}>
    <IconButton size="medium" onClick={(e) => setAnchorEl(e.currentTarget)}>
      <MoreVert />
    </IconButton>
    <Menu
      disabled={disabled}
      id="contextual-resource-edit-menu"
      anchorEl={anchorEl}
      keepMounted
      open={Boolean(anchorEl)}
      onClose={() => setAnchorEl(null)}
    >
      {menuItems}
    </Menu>
  </span>
}

ContextualMenu.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    action: PropTypes.func,
    to: PropTypes.string,
    className: PropTypes.string,
  })),
  dispatch: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string,
}

// sadly, withDispatch doesn't exist but this is what it does and lets us avoid
// uselessly passing down dispatch multiple prop levels
export default connect(null, (dispatch) => ({ dispatch }))(ContextualMenu)
